import { render, staticRenderFns } from "./ModalCadastraAtividadeDisciplinaHabilidade.vue?vue&type=template&id=551e10ce"
import script from "./ModalCadastraAtividadeDisciplinaHabilidade.vue?vue&type=script&lang=js"
export * from "./ModalCadastraAtividadeDisciplinaHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports